var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._l((22),function(n){return _c('BackgroundBeam',{key:`bb-${n}`,attrs:{"getRandomFloat":_vm.getRandomFloat}})}),_vm._l((10),function(n){return _c('LightBeam',{key:`lb-${n}`,attrs:{"getRandomFloat":_vm.getRandomFloat}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }